import React from "react";
import { Grid, Card, useTheme } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { hasModule } from "../../utils/moduleHelpers";
import { MODULES } from "../../config/modules";

import "./Aihub.css";

const Aihub = () => {
  const { tokens } = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <div>
        <h1>AI Solution Hub</h1>
        <Grid
          templateColumns={{ base: "1fr" }}
          gap={tokens.space.xl}
        >
          {/* Top Row */}
          <div className="top-row">
            <Grid
              templateColumns={{ base: "1fr", medium: "1fr 1fr", large: "1fr 1fr 1fr 1fr" }}
              gap={tokens.space.medium}
            >
              {hasModule(MODULES.CHAT) && (
                <Card className="solution-card" onClick={() => navigate("/chat")}>
                  <div
                    className="card-image document-chat-image"
                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/documentchat.jpg)` }}
                  >
                    <div className="arrow-icon">
                      <FaArrowRight />
                    </div>
                  </div>
                  <h3>Document Chat</h3>
                </Card>
              )}

              {hasModule(MODULES.DOC_FINDER) && (
                <Card
                  className="solution-card"
                  onClick={() => navigate("/docfinder")}
                >
                  <div
                    className="card-image document-finder-image"
                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/documentfinder.jpg)` }}
                  >
                    <div className="arrow-icon">
                      <FaArrowRight />
                    </div>
                  </div>
                  <h3>Document Finder</h3>
                </Card>
              )}

              {hasModule(MODULES.CONSISTENCY_GUARD) && (
                <Card
                  className="solution-card"
                  onClick={() => navigate("/consguard")}
                >
                  <div
                    className="card-image consistency-guard-image"
                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/consistencyguard.jpg)` }}
                  >
                    <div className="arrow-icon">
                      <FaArrowRight />
                    </div>
                  </div>
                  <h3>Consistency Guard</h3>
                </Card>
              )}

              {hasModule(MODULES.QNA) && (
                <Card
                  className="solution-card"
                  onClick={() => navigate("/qadashboard")}
                >
                  <div
                    className="card-image qa-population-image"
                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/GenQ&A.jpg)` }}
                  >
                    <div className="arrow-icon">
                      <FaArrowRight />
                    </div>
                  </div>
                  <h3>Q&A Auto-population</h3>
                </Card>
              )}
            </Grid>
          </div>
        </Grid>
      </div>
    </>
  );
};

export default Aihub;
